import React, { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

import CreateMoreWorkspacesModal from 'Shared/components/modals/CreateMoreWorkspacesModal/CreateMoreWorkspacesModal';
import SimpleAddMultipleTemmatesModal from 'Shared/components/modals/SimpleAddWorkspaceModals/SimpleAddMultipleTemmatesModal/SimpleAddMultipleTemmatesModal';
import SimpleAddTeammateModal from 'Shared/components/modals/SimpleAddWorkspaceModals/SimpleAddTeammateModal/SimpleAddTeammateModal';

type Props = {
  onRedirectTo: Function;
};

function AddTeammateModalHandler({ onRedirectTo }: Props) {
  const { search, pathname } = useLocation();
  const { simpleInviteModal: simpleInviteModalFlag } = useFlags();

  const isAddTeammateModalOpen = useCallback(search.includes('add_teammate_open'), [search]);
  const isTrackFinishedOnboarding = useCallback(search.includes(QueryParamsConstants.TRACK_FINISHED_ONBOARDING), [
    search,
  ]);

  const isAddMultipleTeammateModalOpen = useCallback(search.includes('add_multiple_teammates_open'), [search]);

  const handleAddTeammateClose = useCallback(() => onRedirectTo(pathname), [onRedirectTo, pathname]);

  if (!isAddTeammateModalOpen && !isAddMultipleTeammateModalOpen) return null;

  if (isAddMultipleTeammateModalOpen) return <SimpleAddMultipleTemmatesModal onClose={handleAddTeammateClose} />;

  if (isAddTeammateModalOpen && isTrackFinishedOnboarding)
    return (
      <CreateMoreWorkspacesModal
        onClose={handleAddTeammateClose}
        title="Create 1:1 Workspaces"
        createNameSectionTitle="List your teammates below to create a 1:1 workspace for each one"
      />
    );

  return simpleInviteModalFlag ? (
    <SimpleAddTeammateModal onClose={handleAddTeammateClose} />
  ) : (
    <CreateMoreWorkspacesModal onClose={handleAddTeammateClose} />
  );
}

export default AddTeammateModalHandler;
